import { EUserPermissions } from '@zunta/configurations'

const metaWithManager = {
  requiresAuth: true,
  onlyChainUser: true
}

export default [
  {
    name: 'management-residents',
    path: 'residents',
    meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_RESIDENTS] },
    component: () => import('@/views/app/management/residents/Residents.vue')
  },
  {
    path: 'residents/:id',
    name: 'management-resident',
    meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_RESIDENTS] },
    component: () => import('@/views/app/management/residents/resident-page/Resident.vue'),
    children: [
      {
        path: 'aging',
        name: 'management-resident-aging',
        meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_RESIDENTS] },
        component: () => import('@/views/app/management/residents/resident-page/tabs/ResidentAgingTab.vue')
      },
      {
        path: 'auto-payments',
        name: 'management-resident-auto-payments',
        meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_RESIDENTS] },
        component: () => import('@/views/app/management/residents/resident-page/tabs/ResidentAutoPaymentTab.vue')
      },
      {
        path: 'payments-history',
        name: 'management-resident-payments-history',
        meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_RESIDENTS, EUserPermissions.VIEW_PAYMENTS] },
        component: () => import('@/views/app/management/residents/resident-page/tabs/ResidentPaymentHistoryTab.vue')
      },
      {
        path: 'history',
        name: 'management-resident-history',
        meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_RESIDENTS] },
        component: () => import('@/views/app/management/residents/resident-page/tabs/ResidentHistoryTab.vue')
      },
      {
        path: 'statements',
        name: 'management-resident-statement',
        meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_RESIDENTS, EUserPermissions.VIEW_MAILINGS] },
        component: () => import('@/views/app/management/residents/resident-page/tabs/ResidentStatementsTab.vue')
      },
      {
        path: 'resident-contacts',
        name: 'management-resident-contacts',
        meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_RESIDENTS] },
        component: () => import('@/views/app/management/residents/resident-page/tabs/ResidentContactsTab.vue')
      },
      {
        path: 'payment-methods',
        name: 'management-resident-payment-methods',
        meta: { ...metaWithManager, permissions: [EUserPermissions.VIEW_RESIDENTS] },
        component: () => import('@/views/app/management/residents/resident-page/tabs/ResidentPaymentMethodsTab.vue')
      }
    ]
  }
]
